import { render, staticRenderFns } from "./plans.vue?vue&type=template&id=1b782164&"
import script from "./plans.vue?vue&type=script&lang=js&"
export * from "./plans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports